<script lang="ts" setup>
import { ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'
import RModal from '~/components/organs/Modal.vue'
import { closeModal } from '~/utils/Modal'

interface Props {
  name: string
}

defineProps<Props>()
const emit = defineEmits<{
  (e: 'delete'): void
}>()

const deleteFile = () => {
  emit('delete')
  closeModal()
}

</script>

<template>
  <RModal
    ref="refModal"
    name-modal="deleteFileModal"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="deleteFileModalLabel"
      >
        Удалить папку «{{ name }}»?
      </h5>
    </template>
    
    <template #body>
      <div class="body">
        <span class="d-block mb-lg-3">
          После удаления папки «{{ name }}» карточки из этой папки будут отображаться в разделе «Все карточки»
        </span>
      </div>
    </template>
    <template #footer>
      <AButton
        :button-style="ButtonStyle.Danger"
        @click="deleteFile"
      >
        Да, удалить
      </AButton>
    </template>
  </RModal>
</template>

<style lang="scss" scoped></style>
